import { http, pHttp, buildParams } from "./http";

export const getAll = (source: string) => 
  http.get<any, any>(`/branches/get?company=${source}`)

export const getBranch = (id: number) => 
  http.get<any, any>(`/branches/list/${id}`)

export const getBranchesStaffs = (id: number) => 
  http.get<any, any>(`/branches/list/${id}/staffs`)